import {AuthorizationOdontoStatusEnum} from '../../constants/authorizationOdontoStatus';

interface FilterProps {
	active: boolean;
	title: string;
	onClick: () => void;
	category: AuthorizationOdontoStatusEnum | string;
	label: string;
	dataTagId?: string;
}

interface AuthorizationsOdontoFilterProps {
	reset?: () => void;
	totalItems?: number;
	isLoadingItems?: boolean;
}

enum OdontoFilterEnum {
	ALL = 'todos',
}

export type {FilterProps, AuthorizationsOdontoFilterProps};
export {OdontoFilterEnum};
